import { AppBar, InputBase, MenuItem, styled } from '@mui/material';

export const StyledAppBar = styled(AppBar)`
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  position: fixed;
  background-color: ${({ theme }) => theme.palette.blue.notego};
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[200]};
  box-shadow: none;
`;

export const Search = styled('div')`
  position: relative;
  border-radius: 23px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 378px;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[200]};
  }
  margin-right: ${({ theme }) => theme.spacing(2)};
  margin-left: 0;

  ${({ theme }) => theme.breakpoints.down('md')} {
    min-width: 240px;
    max-width: 280px;
    margin-right: ${({ theme }) => theme.spacing(1)};
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    min-width: 180px;
    max-width: 220px;
  }
`;

export const SearchIconWrapper = styled('div')`
  color: ${({ theme }) => theme.palette.text.secondary};
  padding: 0 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledInputBase = styled(InputBase)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;

  width: 100%;
  & .MuiInputBase-input {
    padding: 10px 0px 10px 12px;
    width: 100%;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  cursor: inherit;
  flex-direction: column;
  align-items: start;

  &:hover {
    background-color: ${({ theme }) => theme.palette.common.white};
  }
`;
